module.exports = "<app-aside-nav></app-aside-nav>\n<div class=\"m-grid__item m-grid__item--fluid m-wrapper\">\n\t<router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// D:/Finca/Finca UI/UI/src/app/theme/pages/subheader-type-search/subheader-type-search.component.html
// module id = ../../../../../src/app/theme/pages/subheader-type-search/subheader-type-search.component.html
// module chunks = main